import { JsonObject, JsonProperty } from 'json2typescript';
import { UpperCaseConverter } from './converters';
import { VEHICLE_TYPES } from '../const/app';

// Set on a transport segment that is sold under a flight number but is actually
// operated as a bus or a train (e.g. Farelogix/LH rail replacement). The segment
// itself keeps reporting `vehicles: ['Plane']` so that icons, logos, filters and
// the flight number stay untouched - this model only carries the real mode.
@JsonObject('GroundTransportModel')
export default class GroundTransportModel {
  @JsonProperty('vehicle', UpperCaseConverter, true) public vehicle:VEHICLE_TYPES = undefined;
  @JsonProperty('product', String, true) public product:string = undefined;
}
